import React, { Fragment, useState } from "react";
import { Recaptcha } from "../Recaptcha/Recaptcha.jsx";
import ValidatedTextInput from "../ValidatedTextInput/ValidatedTextInput.jsx";
import "./styles.scss";
import { Modal } from "react-bootstrap";
import axios from "axios";
import { toast } from "ToastAlertContainer";
import window from "global";

const EmailListSubscriptionRequestModal = (props) => {
  let first;
  let last;
  let emailAddress;
  let linkedIn;
  let companySubscribeNoteText;

  let localStorage;

  if (typeof window !== "undefined") {
    localStorage = window.localStorage ? window.localStorage : undefined;
  }

  if (localStorage) {
    first = localStorage.getItem("firstName");
    last = localStorage.getItem("lastName");
    emailAddress = localStorage.getItem("email");
    linkedIn = localStorage.getItem("linkedinUrl");
    companySubscribeNoteText = localStorage.getItem("companySubscribeNote");
  }

  let [firstName, setFirstName] = useState(first ? first : "");
  let [lastName, setLastName] = useState(last ? last : "");
  let [email, setEmail] = useState(emailAddress ? emailAddress : "");
  let [linkedinUrl, setLinkedinUrl] = useState(linkedIn ? linkedIn : "");
  let [companySubscribeNote, setCompanySubscribeNote] = useState(
    companySubscribeNoteText ? companySubscribeNoteText : ""
  );

  const handleSendSubscriptionRequest = async (
    firstName,
    lastName,
    email,
    linkedinUrl,
    companySubscribeNote
  ) => {
    let localStorage;

    if (typeof window !== undefined) {
      localStorage = window.localStorage ? window.localStorage : undefined;
    }

    if (localStorage) {
      localStorage.setItem("firstName", firstName);
      localStorage.setItem("lastName", lastName);
      localStorage.setItem("email", email);
      localStorage.setItem("linkedinUrl", linkedinUrl);
      localStorage.setItem("companySubscribeNote", companySubscribeNote);
    }

    let result = {};
    let error;
    try {
      result = await axios.post(
        "/api/v2/companies/" +
          props.company.company_id +
          "/email_lists/" +
          "all_contacts" +
          "/subscription_requests",
        {
          first_name: firstName,
          last_name: lastName,
          email: email,
          linkedin_url: linkedinUrl,
        }
      );
    } catch (err) {
      toast.error("This email has already submitted a request.");
      props.handleClose(true);
      return;
    }
    toast.success("Request sent.");
    props.handleClose(true);
  };

  // "Hello, I found one of your company's update and I didn't have permission to view. Would you mind adding me to future updates? Thank you."
  const [note, setNote] = useState("");

  const validLinkedinTest = (string) => {
    return RegExp(
      "^https?://((www|ww).)?linkedin.com/((in/[^/]+/?)|(pub/[^/]+/((w|d)+/?){3}))$"
    ).test(string);
  };

  const validateEmail = (email) => {
    var re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  return (
    <Modal
      className={"ps-subscription-request-modal"}
      show={props.show && !!props.company.project_id}
      onHide={() => {
        props.handleClose(false);
      }}
      animation={false}
      centered
      keyboard
    >
      <div
        className="ps-subscription-request-modal__cancel-icon-container"
        onClick={() => {
          props.handleClose(false);
        }}
      >
        <img
          className="ps-subscription-request-modal__cancel-icon"
          src="/images/icons/black-x-mark.svg"
        />
      </div>
      <div>
        <div className={"ps-subscription-request-modal__title-box"}>
          {/* <div className={"ps-subscription-request-modal__logo-box"}>
            {props.company && ( 
              <img
                className={"ps-subscription-request-modal__secondary-logo"}
                src={props.company.secondary_logo_url}
                alt=""
              />
            )}
          </div> */}
          <span className={"ps-subscription-request-modal__title"}>
            Subscribe To Updates
          </span>
          <span className={"ps-subscription-request-modal__subtitle"}>
            {props.company && (
              <Fragment>
                <span>
                  {"Provide your name and email to request to be added to " +
                    props.company.display_name +
                    "'s updates. Or "}
                </span>
                <a href={"/signup?refer=/" + props.company.name}>signup</a>
                <span>
                  {
                    ", to more easily manage communications and subscriptions on Paperstreet."
                  }
                </span>
              </Fragment>
            )}
          </span>
        </div>
      </div>
      <hr />
      <div>
        <div className={"ps-subscription-request-modal__content-box"}>
          <div className={"mb-1 d-flex flex-column justify-space-between"}>
            <div className="d-flex flex-row">
              <div className="ps-subscription-request-modal__first-name">
                <label htmlFor="">First name</label>
                <input
                  autoFocus
                  placeholder="First name"
                  type="text"
                  onChange={(e) => {
                    setFirstName(e.target.value);
                  }}
                  value={firstName}
                  className="input-text--primary ps-edit-contact-modal__input"
                />
              </div>
              <div className="">
                <label htmlFor="">Last name</label>
                <input
                  placeholder="Last name"
                  type="text"
                  onChange={(e) => {
                    setLastName(e.target.value);
                  }}
                  value={lastName}
                  className="input-text--primary ps-edit-contact-modal__input"
                />
              </div>
            </div>
            <div className={"mt-3"}>
              <ValidatedTextInput
                placeholder="Email"
                type="email"
                name="email"
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                errorMessage="Please enter a valid email"
                validator={validateEmail}
                handleInputChange={(e) => {
                  setEmail(e.target.value);
                }}
                value={email}
                displayName={"Email address"}
                inputClassNames={
                  "input-text--primary ps-edit-contact-modal__input"
                }
              />
            </div>
            <div style={{ marginTop: "10px", marginBottom: "10px" }}>
              <div>
                <ValidatedTextInput
                  placeholder="Your LinkedIn URL"
                  type="url"
                  name="linkedin_url"
                  errorMessage={"Please enter a valid LinkedIn URL"}
                  validator={validLinkedinTest}
                  handleInputChange={(e) => {
                    setLinkedinUrl(e.target.value);
                  }}
                  value={linkedinUrl}
                  displayName={"LinkedIn URL"}
                  inputClassNames={
                    "input-text--primary ps-subscription-request-modal__input"
                  }
                />
              </div>
            </div>
            {/* <div style={{ marginBottom: "20px" }}>
              <label>Note</label>
              <textarea
                // disabled={pending}
                className={
                  note.length === 500
                    ? "input-textarea--primary ps-connection-request-modal__input ps-connection-request-modal__input--full"
                    : "input-textarea--primary ps-connection-request-modal__input"
                }
                value={companySubscribeNoteText}
                onChange={(e) => {
                  setNote(e.target.value);
                }}
                maxLength="500"
                name=""
                id=""
                cols="30"
                rows="10"
              />
            </div> */}
          </div>
        </div>
      </div>
      <div className={"ps-subscription-request-modal__footer-box"}>
        <React.Fragment>
          <Recaptcha
            classes={"btn ps-btn--primary ps-btn--full"}
            callback={() => {
              handleSendSubscriptionRequest(
                firstName,
                lastName,
                email,
                linkedinUrl
              );
            }}
            label={"Submit →"}
            validEmail={validateEmail(email)}
          />
        </React.Fragment>
      </div>
    </Modal>
  );
};

module.exports.EmailListSubscriptionRequestModal =
  EmailListSubscriptionRequestModal;
